import { Injectable } from '@angular/core';

@Injectable()
export class HomeService {

  public code?: number;
  public token!: string;
  public body!: {};

  get status() {
    return this.code;
  }

  set status(obj) {
    this.code = obj;
  }

  get authorization() {
    return this.token;
  }

  set authorization(obj) {
    this.token = obj;
  }

  get pdfData() {
    return this.body;
  }

  set pdfData(obj) {
    this.body = obj;

  }
}
